import React, { useState } from 'react';
import { useAddTagSuggestions } from '../../hooks/useTags';
import { MsComboBox } from '../MsComboBox';

interface TagRef { id: string; name: string; color: string; }

interface Props {
  id?: string;
  projectId: string;
  selected: TagRef[];
  onChange: (tags: TagRef[]) => void;
  disabled?: boolean;
  testId?: string;
}

export function TagRelationshipPicker({ id, projectId, selected, onChange, disabled, testId }: Props) {
  const [query, setQuery] = useState('');
  const { data: suggestions = [] } = useAddTagSuggestions(projectId, query, true);

  return (
    <MsComboBox<TagRef>
      id={id}
      testId={testId}
      selected={selected}
      suggestions={suggestions}
      onChange={disabled ? () => {} : onChange}
      onQueryChange={setQuery}
      getKey={t => t.id}
      getLabel={t => t.name}
      getColor={t => t.color}
      icon="fa-circle"
    />
  );
}
